import { useEffect } from 'react'

export const useGoogleRecaptcha = () => {
    useEffect(() => {
        if (window.GOOGLE_RECAPTCHA_KEY) {
            const recaptchaExists = document.getElementById('recaptcha')

            if (!recaptchaExists) {
                const script = document.createElement('script')
                script.type = 'text/javascript'
                script.src = `https://www.google.com/recaptcha/api.js?render=${window.GOOGLE_RECAPTCHA_KEY}`
                script.id = 'recaptcha'
                document.body.appendChild(script)
            }
        }
    }, [])
}
